// import node module libraries
import {Fragment, useEffect, useState} from 'react';
import {Breadcrumb, Button, Card, Col, Offcanvas, Row, Tab} from 'react-bootstrap';

// import custom components
import OffcanvasAddContratForm from '../add-new-contrat/OffcanvasAddContratForm';

// import sub components
import ContratListItems from './ContratListItems';
import ContratService from '../../services/ContratService';
import PersonnelService from "../../services/PersonnelService";

const Contrat = () => {
    const [contrats, setContrats] = useState([]);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [activePersonnel, setActivePersonnel] = useState([]);

    useEffect(() => {
        // Fetch active personnel
        PersonnelService.getAllActivePersonnels().then((response) => {
            setActivePersonnel(response);
        });
    }, []);

    useEffect(() => {
        if (activePersonnel.length > 0) {
            // Fetch contracts
            ContratService.getAllContrats().then((response) => {
                // Filter contracts for active personnel
                const activeContracts = response.filter((contrat) =>
                    activePersonnel.some((person) => person.id === contrat.personnel)
                );
                setContrats(activeContracts);
            });
        }
    }, [activePersonnel]);

    return (
        <Fragment>
            <Tab.Container defaultActiveKey="list">
                <Row>
                    <Col lg={12} md={12} sm={12}>
                        <div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
                            <div className="mb-3 mb-md-0">
                                <h1 className="mb-1 h2 fw-bold">
                                    Contrat{' '}
                                    <span className="fs-5 text-muted"> ({contrats.length})</span>
                                </h1>
                                <Breadcrumb>
                                    <Breadcrumb.Item href="/">
                                        Accueil
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>
                                        Contrat
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <Button onClick={handleShow}>Ajouter un contrat</Button>
                                    <Offcanvas
                                        show={show}
                                        onHide={handleClose}
                                        placement="end"
                                        name="end"
                                        style={{width: '600px'}}
                                    >
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title as="h3">
                                                Enregistrer un contrat
                                            </Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <Offcanvas.Body className="pt-0">
                                            <OffcanvasAddContratForm onClick={handleClose}/>
                                        </Offcanvas.Body>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Tab.Content>
                    <Tab.Pane eventKey="list" className="pb-4">
                        <Card className="mb-5 ">
                            <Card.Body className="p-0">
                                <ContratListItems/>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Fragment>
    );
};
export default Contrat;
